import AjaxComponentLoader from 'utils/ajax_component_loader';

export default class ActivitiesList {
  static getList(page, userId = null, source = null) {
    const data = {};
    if (userId) {
      data.user_id = userId;
    }

    if (source) {
      data.source = source;
    }

    return AjaxComponentLoader.load({
      component: 'timeline/activities_list',
      type: 'page_component',
      data: data,
      params: {
        page
      }
    });
  }
}
